module.exports = __webpack_public_path__ + "static/media/comprehensive_shift_information.e8906a1b.png";